import React from 'react';
import { Hero } from '../components/Hero';
import { Consultation } from '../components/Consultation';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-577" data-mp="22175p1bcrts3">
      
      <Navigation data-id="element-578" data-mp="1x7ur7k0e13d2" />

      <main data-id="element-579" data-mp="2b0kh3zj1esfg">
        <Hero data-id="element-580" data-mp="2b0aqqau2yj98" />
        <Consultation data-id="element-581" data-mp="2azrkhrdsljb1" />
      </main>

      <Footer data-id="element-582" data-mp="2aypveizxywab" />
    </div>;
}